import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { captureAnalyticsEvent } from "@-/dev.improve.haniverse.lib.analytics";
import {
  tableNameMatcher,
  useTableChangeVersion,
} from "@-/dev.improve.haniverse.lib.database.change";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import {
  claimDailyLoginReward,
  isDailyLoginRewardClaimable,
  rewardDayKey,
} from "#daily-login-reward";

function useGetDailyLoginRewardQueryKey() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const withTableChangeVersion = useTableChangeVersion(tableNameMatcher(["reward_claim", "user"]));
  // The day is part of the key, so the envelope reappears after local midnight.
  return () =>
    withTableChangeVersion([
      "dailyLoginReward",
      { actorDb, day: rewardDayKey(new Date()) },
    ] as const);
}

/** Whether today's 红包 is unclaimed, and what it holds. */
export const [useDailyLoginRewardQueryOptions] = createUseQueryOptions(
  useGetDailyLoginRewardQueryKey,
  async ({ queryKey: [_, { actorDb }] }) =>
    isDailyLoginRewardClaimable({ actorDb: actorDb(import.meta.location), now: new Date() }),
);

export function useClaimDailyLoginRewardMutation() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  return useMutation({
    mutationFn: () =>
      claimDailyLoginReward({ actorDb: actorDb(import.meta.location), now: new Date() }),
    mutationKey: ["hanCurrency", "claimDailyLoginReward"],
    onSuccess: (claimed) => {
      // `null`: today's envelope was already claimed (another tab or device got there first).
      if (claimed !== null) {
        captureAnalyticsEvent("daily_reward_claimed", {
          cycle_day: claimed.cycleDay,
          han: claimed.han,
        });
      }
    },
  });
}
